import { render, staticRenderFns } from "./modalRpa.vue?vue&type=template&id=47f5b6bd&scoped=true"
import script from "./modalRpa.vue?vue&type=script&lang=js"
export * from "./modalRpa.vue?vue&type=script&lang=js"
import style0 from "./modalRpa.vue?vue&type=style&index=0&id=47f5b6bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5b6bd",
  null
  
)

export default component.exports